module.exports = __webpack_public_path__ + "static/media/halloween-kidspack-dt-en.01b54808.jpg";